import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

 function getCookie(name) {
        const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return cookieValue ? cookieValue.pop() : '';
      }


const LoginRoute = ({children}) => {

   
      
    const location = useLocation();
    const [token, setToken] = useState(getCookie("WFL_token"));

    if(!token){
        return children;
        
    }
    else if(token){
        return <Navigate to='/dashboard' state={{from:location}} replace ></Navigate>

    }
 
   

  
   
}

export default LoginRoute;